// extracted by mini-css-extract-plugin
export default {"hvnly-settings-api__contents":"_vMvPAqqQM8Mg51E0CuQ"};